import type {AssigneePickerBaseProps} from './AssigneePickerBase'
import {CompressedAssigneeAnchor} from './CompressedAssigneeAnchor'

type DefaultAssigneePickerAnchorProps = Pick<AssigneePickerBaseProps, 'assignees' | 'readonly'> & {
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
} & {ref?: React.Ref<HTMLButtonElement>}

export const DefaultAssigneePickerAnchor = ({
  ref,
  assignees,
  readonly,
  anchorProps,
}: DefaultAssigneePickerAnchorProps) => {
  return (
    <CompressedAssigneeAnchor
      assignees={assignees || []}
      displayHotkey={false}
      anchorProps={readonly ? undefined : anchorProps}
      readonly={readonly}
      ref={ref}
    />
  )
}

DefaultAssigneePickerAnchor.displayName = 'DefaultAssigneePickerAnchor'
